import React, { useEffect, useState } from 'react';
import { createFilterOptions } from '@mui/material';

import { Autocomplete, Chip, List } from '@atom/mui';
import colors from '@atom/styles/colors';
import { TaskField } from '@atom/types/task';

const { ListItemText } = List;

const styles = {
  label: {
    position: 'unset',
    color: `${colors.neutral.dim} !important`,
  },
  chip: {
    marginTop: '5px',
    marginRight: '5px',
    backgroundColor: colors.neutral.ash,
    borderRadius: '20px',
  },
};

const filterOptions = createFilterOptions<string>({
  matchFrom: 'any',
  limit: 250,
});

interface Props {
  field: TaskField;
  onChange: (fieldId: string, value: any) => void;
  isDisabled?: boolean;
  previewView?: boolean;
  error?: boolean;
  helperText?: string;
  onClick?: () => void;
  taskId?: string;
}

const TaskEnumMultipleField = ({
  field,
  onChange,
  isDisabled,
  previewView,
  error,
  helperText,
  onClick,
}: Props) => {
  const [values, setValues] = useState<string[]>([]);
  const [query, setQuery] = useState<string>('');

  const handleChange = (newValues: string[]) => {
    setValues(newValues);
    onChange(field.id, newValues);
  };

  const handleDeselect = (value: string) => {
    if (isDisabled) {
      return;
    }

    const newValues = values.filter(option => option !== value);
    setValues(newValues);
    onChange(field.id, newValues);
  };

  useEffect(() => {
    setValues(field?.value || []);
    setQuery('');
  }, [field?.value]);

  const title = field.required ? `* ${field.title}` : field.title;
  const selectStyle = {
    flex: previewView ? 1 : 0.66,
  };

  return (
    <>
      <Autocomplete<string, true, true>
        id={field?.id}
        onClick={onClick}
        style={selectStyle}
        multiple
        label={title}
        options={field?.enumeration}
        disabled={isDisabled}
        inputValue={query}
        error={error}
        filterOptions={filterOptions}
        errorHelperText={helperText}
        onInputChange={(event, newQuery) => setQuery(newQuery || '')}
        getOptionLabel={item => item}
        placeholder={!values.length ? 'Search' : ''}
        value={values}
        disableCloseOnSelect
        TextFieldProps={{ onClick }}
        onChange={(event, newValues) => {
          handleChange(newValues);
        }}
        renderOption={(optionProps, item) => (
          <li key={item} {...optionProps}>
            <ListItemText primary={item} />
          </li>
        )}
        renderTags={selected => {
          return selected.map(item => (
            <Chip
              key={item}
              style={styles.chip}
              label={item}
              onDelete={() => handleDeselect(item)}
            />
          ));
        }}
        labelStyle={styles.label}
      />
    </>
  );
};

export default TaskEnumMultipleField;
